import type { ColoredMaterial } from "@color-finder/color-finder-api/models";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { TextDisplay } from "components/dataDisplay/TextDisplay";
import type { FC } from "react";

export interface CompetitorInformationProps {
  material: ColoredMaterial;
}

export const CompetitorInformation: FC<CompetitorInformationProps> = ({
  material,
}) => {
  return (
    <Grid container spacing={1}>
      <Grid size={5}>
        <Typography variant="label">Competitor</Typography>
      </Grid>
      <Grid size={7}>
        <TextDisplay value={material.competitor?.competitorName} />
      </Grid>
      <Grid size={5}>
        <Typography variant="label">Competitor color code</Typography>
      </Grid>
      <Grid size={7}>
        <TextDisplay value={material.competitor?.competitorColorCode} />
      </Grid>
    </Grid>
  );
};
